/**
 * The Tooltips in the Design System are not focusable by default.
 * This logic is used to remove the focusability of the anchor tags
 * nested inside the tooltips.
 */
export function removeAnchorTagFocus(htmlString = "") {
    if (typeof window !== 'undefined') {
        const parent = window.document.createElement('div');
        parent.innerHTML = htmlString;
        parent.querySelectorAll('a').forEach((anchor) => {
            anchor.setAttribute('tabindex', '-1');
        });
        return parent.innerHTML;
    }
    return htmlString;
}
//# sourceMappingURL=removeAnchorTagFocus.js.map